import {createSlice} from '@reduxjs/toolkit';
import { getToken } from './thunk';

export const initialState = {
    token: "",
    error: {},
};

const tokenslice = createSlice({
    name: 'token',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getToken.fulfilled, (state, action) => {
            state.token = action.payload;
        });
        builder.addCase(getToken.rejected, (state, action) => {
            state.error = action.payload.error || null;
        });
    }
});

export default tokenslice.reducer;